import { deleteApi, get, post } from "../GenericServices";

const AccountingBookExport = {
  getBookExportsInfo: () => {
    return get(`accounting-book-export/info`);
  },
  getBookExports: (queryString) => {
    return get(`accounting-book-export${queryString !== "" ? `?${queryString}` : ""}`);
  },
  downloadBookExport: (yearMonth) => {
    return get(`accounting-book-export/download/${yearMonth}`, {}, "blob");
  },
  createBookExport: (yearMonthFrom, yearMonthTo) => {
    return post(`accounting-book-export/create/${yearMonthFrom}/${yearMonthTo}`);
  },
  deleteBookExport: (yearMonth) => {
    return deleteApi(`accounting-book-export/${yearMonth}`);
  },
};

export default AccountingBookExport;
